import { toast } from "react-toastify";

const styles = {
  default: "toast toast-default",
  success: "toast toast-success",
  error: "toast toast-error",
  warning: "toast toast-warning",
  info: "toast toast-info",
  dark: "toast toast-dark"
};

const TIMEOUT = 5 * 1000; // 5 Секунд

function getOptions(style) {
  return {
    position: toast.POSITION.BOTTOM_LEFT,
    autoClose: TIMEOUT,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    className: styles[style] || ""
  };
}

function showMessage(message, style = "default") {
  if (message) {
    switch (style) {
      case toast.TYPE.WARNING:
        toast.warn(message, {
          ...getOptions(style)
        });
        break;
      case toast.TYPE.ERROR:
        toast.error(message, {
          ...getOptions(style)
        });
        break;
      case toast.TYPE.SUCCESS:
        toast.success(message, {
          ...getOptions(style)
        });
        break;
      case "dark":
        toast.info(message, {
          ...getOptions(style)
        });
        break;
      default:
        toast.info(message, {
          ...getOptions(style)
        });
        break;
    }
  }
}

export default {
  alert: message => showMessage(message, toast.TYPE.DEFAULT),
  default: message => showMessage(message, toast.TYPE.DEFAULT),
  success: message => showMessage(message, toast.TYPE.SUCCESS),
  error: message => showMessage(message, toast.TYPE.ERROR),
  warn: message => showMessage(message, toast.TYPE.WARNING),
  warning: message => showMessage(message, toast.TYPE.WARNING),
  info: message => showMessage(message, toast.TYPE.INFO),
  dark: message => showMessage(message, "dark")
};
